import React from 'react';
import { motion } from 'framer-motion';
import { Search, Heart, PackageCheck, Sparkles } from 'lucide-react';

const ProcessSection = () => {
  const steps = [
    {
      num: '01',
      title: 'Discover',
      description: 'Explore our carefully selected divine products and authentic Himalayan offerings.',
      icon: Search,
    },
    {
      num: '02',
      title: 'Choose',
      description: 'Find the product that resonates deeply with your spiritual intention and personal space.',
      icon: Heart,
    },
    {
      num: '03',
      title: 'Receive',
      description: 'We carefully prepare, sanctify, and securely deliver your order straight from Uttarakhand.',
      icon: PackageCheck,
    },
    {
      num: '04',
      title: 'Experience',
      description: 'Bring its peaceful divine presence into your home, rituals, and daily meditation.',
      icon: Sparkles,
    },
  ];

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-12 bg-[#FBF4E7] relative overflow-hidden border-t border-[#E7D9BC]">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-[#B85A15]">
            OUR SACRED JOURNEY
          </span>
          <h2 className="font-serif-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#4E1225] mt-2">
            From Our Hands to Your Sacred Space
          </h2>
          <p className="text-[#83725B] mt-2 text-sm sm:text-base">
            Every step is handled with utmost reverence, purity, and devotion to ensure complete sanctity.
          </p>
          <div className="flex items-center justify-center gap-2 mt-4">
            <span className="w-12 h-px bg-[#B98B3E]/50" />
            <span className="w-2 h-2 bg-[#B98B3E] rotate-45" />
            <span className="w-12 h-px bg-[#B98B3E]/50" />
          </div>
        </div>

        {/* Process Timeline */}
        <div className="relative">
          <div className="hidden lg:block absolute top-[44px] left-[12%] right-[12%] h-[2px] bg-gradient-to-r from-transparent via-[#B98B3E]/40 to-transparent z-0" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps.map((step, index) => {
              const IconComp = step.icon;
              return (
                <motion.div
                  key={step.num}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.15, duration: 0.6 }}
                  className="flex flex-col items-center text-center group"
                >
                  <div className="w-18 h-18 rounded-full bg-[#F3E7D0] border-2 border-[#E7D9BC] flex items-center justify-center mb-5 relative shadow-xs group-hover:bg-[#6E1B34] group-hover:border-[#6E1B34] transition-all duration-300">
                    <IconComp className="w-7 h-7 text-[#6E1B34] group-hover:text-[#E8D5A8] transition-colors" />
                    <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-[#B98B3E] text-[#4E1225] font-bold text-xs flex items-center justify-center shadow-xs">
                      {step.num}
                    </span>
                  </div>

                  <h3 className="font-serif-heading text-lg font-bold text-[#4E1225] mb-1.5 group-hover:text-[#D9711F] transition-colors">
                    {step.title}
                  </h3>
                  <p className="text-xs text-[#83725B] leading-relaxed max-w-xs">
                    {step.description}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ProcessSection;
